import { useSelector } from 'react-redux';

import { useIataCode } from '../../../../hooks';
import { getPassengersIds } from '../model/passengers/selectors';
import { shouldSkipPassengers } from '@shared/lib/passengers';

export const useSkipPassengers = (): boolean => {
	const iataCode = useIataCode();
	const passengersIds = useSelector(getPassengersIds);

	return shouldSkipPassengers(passengersIds.length, iataCode);
};
